<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 电量数据
        </span>
        <div class="normalNav zaddBtn" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1 electric">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="周期">
                <el-select placeholder="请选择周期" v-model="formData.type" @change="bindData">
                  <el-option v-for="item in dataArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="formData.beginDate" :value-format='valueFormat' :type="dataType" placeholder="选择时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="formData.endDate" :value-format='valueFormat' :type="dataType" placeholder="选择时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="设备">
                <el-input v-model="formData.deviceName"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <easyTable apiUrl="operation/mandunStatic/findStatic" :parent="self" :config="config" :other="other" ref="table_jsgl">
            <template slot="first">
              <template slot="last">
                <el-table-column label='设备名称' align="center" prop="device_name"></el-table-column>
              </template>
              <template slot="last">
                <el-table-column label='统计类型' align="center" prop="type" :formatter="typeSymbol"></el-table-column>
              </template>
            </template>
          </easyTable>
        </div>
        <!-- <div class="tableWrapper nonedetailtab" v-if="!showData">
          请搜索
        </div> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      items: [],
      formData: {
        type: "f1",
        beginDate: "",
        endDate: "",
        deviceName: "",
      },
      dataArr: [
        { name: "年", id: "f4" },
        { name: "月", id: "f2" },
        { name: "日", id: "f1" },
      ],
      valueFormat: "yyyy-MM-dd ",
      form_jsgl: {},
      dataType: "date",
      key: "",
      title: "",
      tabName: "jsgl",
      showTable: true,
      other: {},
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "vol",
          label: "电压值",
        },
        {
          prop: "cur",
          label: "电流值",
        },
        {
          prop: "tmp",
          label: "温度值",
        },
        {
          prop: "lki",
          label: "漏电流值",
        },
        {
          prop: "ps",
          label: "区间电量",
        },
        {
          prop: "static_time",
          label: "统计时间",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    easyTable: () => import("public/easyTable"),
    searchForm: () => import("public/searchForm"),
    mountPoint: () => import("public/mountPoint"),
  },
  mounted() {},
  methods: {
    typeSymbol(row, column) {
      return row.type == "f1" ? "日" : row.type == "f2" ? "月" : "年";
    },
    bindData() {
      let data = this.formData;
      if (data.type == "f1") {
        this.dataType = "date";
        data.beginDate = "";
        data.endDate = "";
        this.valueFormat = "yyyy-MM-dd";
      } else if (data.type == "f4") {
        this.dataType = "year";
        data.beginDate = "";
        data.endDate = "";
        this.valueFormat = "yyyy-MM-dd";
      } else {
        this.dataType = "month";
        data.beginDate = "";
        data.endDate = "";
        this.valueFormat = "yyyy-MM-dd";
      }
    },
    reset() {
      this.formData = {
        type: "f1",
        beginDate: "",
        endDate: "",
        deviceName: "",
      };
      this.dataType = "date";
      this.valueFormat = "yyyy-MM-dd";
    },
    subSeefrom() {
      let data = this.formData;
      this.other = {
        ...this.formData,
      };
      // this.parent.$refs[table].pageToOne();
      this.$nextTick(this.$refs.table_jsgl.getData);
    },
  },
};
</script>
<style lang='less'>
.dataTj {
  thead .el-table-column--selection .cell {
    display: none;
  }
}
</style>

<style scoped lang="less">
.nonedetailtab {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(181, 181, 181);
}
.electric .el-form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
  .el-date-editor {
    width: calc(100%);
  }
  .el-range-input {
    background: #2e3657;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/deviceData/electricData.vue